module.exports = __webpack_public_path__ + "static/img/patentTop.297eeb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/patentTop.jpg
// module id = yGGP
// module chunks = 0